<template>
  <div>
    <KTCodePreview v-bind:title="'In biên bản kiểm kê'">
      <template v-slot:toolbar>
        <b-button
          variant="primary"
          size="sm"
          class="font-weight-bolder"
          @click="onClickToPrint(printMode)"
        >
          <i style="font-size: 1rem" class="fas fa-print"></i>In biên bản
        </b-button>
      </template>
      <template v-slot:preview>
        <hr
          class="hr-text"
          data-content="Khổ giấy A4- A5"
          style="font-weight: 600"
        />
        <div id="A4">
          <PrintInventoryCheckComponent :printData="mainModel" />
        </div>
        <br />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import PrintInventoryCheckComponent from './PrintInventoryCheckComponent.vue';
import { TIME_TRIGGER } from '@/utils/constants';
import saveData from '@/utils/saveDataToLocal';
import { handleError } from '@/utils/common';

export default {
  components: {
    KTCodePreview,
    PrintInventoryCheckComponent,
  },
  data() {
    return {
      mainModel: {
        stockCheckSheet: null,
        stockCheckProducts: [],
      },
      printMode: 'A4',
    };
  },
  created() {
    let defaultPrintMode = saveData.getData('defaultPrintMode');
    if (!defaultPrintMode) {
      defaultPrintMode = 'A4';
      saveData.saveData('defaultPrintMode', this.printMode);
    }
    this.printMode = defaultPrintMode;
    const productStockCheckId = this.$route.query.id;
    this.getStockCheckById(productStockCheckId);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kiểm tồn kho', route: '/inventory-check' },
      { title: 'In biên bản kiểm kê' },
    ]);
  },
  methods: {
    getStockCheckById(id) {
      ApiService.get(`v1/stock-check-sheet/print/${id}`).then((response) => {
        const data = response.data.data;

        this.mainModel.stockCheckSheet = {
          id: data.id,
          code: data.code,
          note: data.note,
          status: data.status,
          productType: data.productType,
          createdAt: data.createdAt,
          updatedAt: data.updatedAt,
          storeName: data.storeName,
          createdByName: data.createdByName,
          managerEmployeeName: data.managerEmployeeName,
          employeeCheckers: data.employeeCheckers || [],
          totalAmount: data.totalAmount || 0,
        };

        const toArray = (val) => {
          if (Array.isArray(val)) return val;
          if (typeof val === 'string' && val.trim()) return val.split(',').map((s) => s.trim());
          return [];
        };

        this.mainModel.stockCheckProducts = (data.stockCheckProducts || []).map(
          (product) => {
            const imeiNos = toArray(product.imeiNos);
            return {
              id: product.id,
              productId: product.productId,
              barCode: product.productId,
              productCode: product.productCode,
              productName: product.productName,
              productType: product.productType,
              productImei: imeiNos.join(', '),
              unit: product.unitName || 'Cái',
              totalQuantityInStock: product.inStockQuantity || 0,
              totalQuantityHolding: product.holdingQuantity || 0,
              totalQuantityWarranty: product.warrantyQuantity || 0,
              totalQuantityError: product.errorQuantity || 0,
              realStockQuantity: product.realQuantity || 0,
              productPrice: product.sellingPrice || 0,
              totalAmount: product.totalAmount || 0,
              imeiNos,
              realImeiNos: toArray(product.realImeiNos),
              imeiMissings: toArray(product.imeiMissings),
              diffQuantity: product.diffQuantity || 0,
              isLackStock: product.isLackStock || false,
              note: product.note || '',
            };
          },
        );
      }).catch((error) => {
        handleError(error);
      });
    },
    printData(mode = 'A4', stylePrint) {
      const prtHtml = document.getElementById(mode).innerHTML;
      let stylesHtml = '';
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        '',
        '',
        'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0',
      );
      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
          ${stylePrint}
        </head>
        <body`);
      WinPrint.document.write(`${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function () {
        WinPrint.print();
      }, TIME_TRIGGER);
    },
    getStylePrint() {
      return `<style>
                .font-size-print {font-size: 20px !important; color: black;}
                .font-size-gift {font-size: 18px !important; color: black;}
                .font-size-name{ font-size: 20px !important; color: black;}
                .font-size-warranty{ font-size: 26px !important; color: black;}
                .font-size-product-info{ font-size: 20px !important; color: black;}
                .font-size-price{ font-size: 30px !important; font-weight: bold !important;}
                .text-download-app {font-size: 14px !important; font-weight: 550 !important; margin-top: 4px;}
                .item-print {
                    width: 100% !important;
                    margin-left: 0px !important;
                  }
                @media print {
                  .signature-section .row {
                    display: flex !important;
                    flex-wrap: nowrap !important;
                  }
                  .signature-section .col {
                    flex: 0 0 33.33% !important;
                    width: 33.33% !important;
                    max-width: 33.33% !important;
                  }
                }
              </style>`;
    },
    onClickToPrint(mode) {
      this.printMode = mode;
      const stylePrint = this.getStylePrint();
      this.printData(mode, stylePrint);
    },
  },
};
</script>
